import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export default function BotFeaturesVideo() {
  const { t } = useLocale('chatbots');

  return (
    <section className='mb-12'>
      <h2 className='mx-auto mt-2  max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent  sm:text-4xl'>
        {t('The simplest way to create powerful chatbots in minutes!')}
      </h2>
      <div className='relative mx-auto my-10 w-full max-w-[75%] rounded-md bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 p-2 shadow-lg xl:max-w-[60%]'>
        <LiteYouTubeEmbed
          id='zrqk3Q5NYZ0'
          title='AI Text to Speech'
          poster='maxresdefault'
          params='rel=0&showinfo=0'
          aspectWidth={16}
          aspectHeight={11}
          rel='0'
        />
      </div>
      <div className='mt-24 sm:flex sm:justify-center'>
        <div className='rounded-md shadow'>
          <Link
            href='/login?preset=bots'
            className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'
          >
            {t('Try it yourself for free')}
          </Link>
        </div>
      </div>
    </section>
  );
}
